import { Alert, Switch } from '@mui/material';
import styled from 'styled-components';

export const Scroller = styled('div')`
  overflow-y: auto;

  /* Firefox */
  & {
    scrollbar-width: auto;
    scrollbar-color: ${({ theme }) =>
      `${theme.color.scrollbar.thumb} ${theme.color.scrollbar.track}`};
  }

  /* Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 16px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => `${theme.color.scrollbar.track}`};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => `${theme.color.scrollbar.thumb}`};
    border-radius: 10px;
    border: 3px solid white;
  }
`;

export const StyledAlert = styled(Alert)`
  color: ${({ theme }) => `${theme.color.border.secondary}`};
  background-color: ${({ theme }) => `${theme.color.main.primary}`};
  margin: 30px;
`;

export const StyledSwitch = styled(Switch).attrs({
  size: 'small',
})`
  .MuiSwitch-switchBase {
    color: ${({ theme }) => theme.color.checkbox.primary};
    + .MuiSwitch-track {
      background-color: ${({ theme }) => theme.color.checkbox.primary};
    }

    &.Mui-checked {
      color: ${({ theme }) => theme.color.main.primary};
      + .MuiSwitch-track {
        background-color: ${({ theme }) => theme.color.main.primary};
      }
    }
  }
`;
